<form [formGroup]="form" class="filters-bar-row">
  <div class="filter-bar-col" [ngClass]="cssColContainer" *ngFor="let filter of filters">

    <!-- SELECT FIELD -->
    <ng-container *ngIf="filter.fieldType == filterFieldType.SELECT">
      <nb-form-field class="filters-form-field">
        <nb-label>{{ filter.label || filter.name | camelToUpper }}</nb-label>

        <!-- Searchable Select -->
        <ng-container *ngIf="filter.searchable">
          <input
            nbInput
            [formControl]="searchFormControl"
            [nbAutocomplete]="auto"
            placeholder="Search venues"
          />
          <nb-autocomplete #auto [handleDisplayFn]="viewHandle">
            <nb-option *ngFor="let datum of getFilteredData(filter)" [value]="datum">
              {{ datum.name }}
            </nb-option>
          </nb-autocomplete>
        </ng-container>

        <!-- Non-searchable Select -->
        <nb-select *ngIf="!filter.searchable"
          [formControlName]="filter.name"
          [status]="isUserSelectedAndNotFirst(filter.name) ? 'primary' : 'basic'"
          (selectedChange)="onSingleSelectionChanged(filter.name, $event)">
          <nb-option disabled class="nb-select-search-option" *ngIf="filter?.data?.length > 10">
            <div class="search-input-wrapper">
              <input nbInput
                     fullWidth
                     placeholder="Search..."
                     [(ngModel)]="filter.searchText"
                     [ngModelOptions]="{ standalone: true }"
                     (click)="$event.stopPropagation()"
                     (keydown)="$event.stopPropagation()" />
                     <button *ngIf="filter.searchText"
                     type="button"
                     class="clear-search-btn"
                     (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                     (click)="$event.stopPropagation();filter.searchText = ''">
               <nb-icon icon="close-outline" pack="eva" class="clear-icon"></nb-icon>
             </button>
            </div>
          </nb-option>
          <nb-option *ngFor="let datum of filter.data" [value]="datum"
          [hidden]="!matchesSearch(datum, filter.searchText)">
          {{ datum.name }} 
          </nb-option>
        </nb-select>
      </nb-form-field>
    </ng-container>

    <!-- INPUT FIELD -->
    <ng-container *ngIf="filter.fieldType == filterFieldType.INPUT">
    <nb-form-field class="search-form-field">
      <nb-icon nbSuffix icon="search-outline" pack="eva"></nb-icon>
      <nb-label>{{ filter.label || filter.name | camelToUpper }}</nb-label>
      <input nbInput [status]="form.get(filter.name)?.value ? 'primary' : 'basic'"
                     [formControlName]="filter.name" [placeholder]="filter.label || filter.name | camelToUpper">
    </nb-form-field>
  </ng-container>

    <!-- MULTI SELECT FIELD -->
    <ng-container *ngIf="filter.fieldType == filterFieldType.Multi_Select">
      <nb-form-field class="filters-form-field">
        <nb-label>{{ filter.label || (filter.name | camelToUpper) }}</nb-label>
        <nb-select
        [formControlName]="filter.name"
        multiple
        [status]="isUserSelectedAndNotFirst(filter.name) ? 'primary' : 'basic'"
        [placeholder]="'None'"
        (selectedChange)="onMultiSelectionChanged(filter.name, $event)">
      
        <!-- Search input as a fake nb-option -->
        <nb-option disabled class="nb-select-search-option" *ngIf="filter?.data?.length > 10">
          <div class="search-input-wrapper">
            <input nbInput
                   fullWidth
                   placeholder="Search..."
                   [(ngModel)]="filter.searchText"
                   [ngModelOptions]="{ standalone: true }"
                   (click)="$event.stopPropagation()"
                   (keydown)="$event.stopPropagation()" />
                   <button *ngIf="filter.searchText"
                   type="button"
                   class="clear-search-btn"
                   (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                   (click)="$event.stopPropagation();filter.searchText = ''">
             <nb-icon icon="close-outline" pack="eva" class="clear-icon"></nb-icon>
           </button>
          </div>
        </nb-option>
        <nb-option *ngFor="let datum of filter.data"
                   [value]="datum"
                   [hidden]="!matchesSearch(datum, filter.searchText)">
          {{ datum.name }}
        </nb-option>
      </nb-select>   
      </nb-form-field>
    </ng-container>  
  </div>

  <div class="filter-reset-button-wrapper">
    <button [nbTooltip]="'Reset Filters'"  class="reset-filters-btn" (click)="onResetFilters()">
      <nb-icon icon="funnel-outline" pack="eva"></nb-icon>
      <span>Reset</span>
    </button>
  </div>
</form>